"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createPublicRuntimeConfig_exports = {};
__export(createPublicRuntimeConfig_exports, {
  default: () => createPublicRuntimeConfig
});
module.exports = __toCommonJS(createPublicRuntimeConfig_exports);
var import_node_process = __toESM(require("node:process"), 1);
var import_helpers = require("../helpers");
const { BASE_URL } = import_node_process.default.env;
function createPublicRuntimeConfig() {
  return {
    axios: {
      baseURL: (0, import_helpers.setProtocol)(BASE_URL, "http"),
      browserBaseURL: (0, import_helpers.setProtocol)(BASE_URL, "https")
    },
    recaptcha: {
      hideBadge: false,
      mode: "base",
      siteKey: import_node_process.default.env.RECAPTCHA_SITE_KEY,
      version: 2,
      size: "normal"
    },
    imagePath: "s3:/",
    fullPath: `${import_node_process.default.env.CDN_URL || "https://cdn1.it4profit.com"}/s3`,
    cdnURL: `${import_node_process.default.env.CDN_URL}/s3`,
    baseUrl: import_node_process.default.env.BASE_URL,
    versionInfo: import_node_process.default.env.BUILD_INFO,
    googleGtagId: import_node_process.default.env.GOOGLE_GTAG_ID,
    fbAnalyticsId: import_node_process.default.env.FB_ANALYTICS_ID,
    twAnalyticsId: import_node_process.default.env.TW_ANALYTICS_ID,
    appEnv: import_node_process.default.env.APP_ENV,
    // Prestigio
    gtmId: import_node_process.default.env.GOOGLE_TAG_MANAGER_ID,
    serviceFormUuid: import_node_process.default.env.SERVICE_FORM_UUID,
    consultSalesFormUuid: import_node_process.default.env.CONSULT_FORM_UUID_SALES,
    consultWarrantyFormUuid: import_node_process.default.env.CONSULT_FORM_UUID_WARRANTY,
    softwareTrialFormUuid: import_node_process.default.env.SOFTWARE_TRIAL_FORM_UUID,
    joinuApp: import_node_process.default.env.JOINU_APP,
    gmapId: import_node_process.default.env.GMAP_ID,
    // Asbis
    showTechisland: import_node_process.default.env.SHOW_TECHISLAND,
    // Mododomus
    consultFormUuid: import_node_process.default.env.CONSULT_FORM_UUID
  };
}
